/**
 * Shared i18n Resources
 * Exports all shared translation resources
 */

// English resources
import commonEn from './en/common.json';
import validationEn from './en/validation.json';
import errorsEn from './en/errors.json';
import authEn from './en/auth.json';

// Ukrainian resources
import commonUk from './uk/common.json';
import validationUk from './uk/validation.json';
import errorsUk from './uk/errors.json';
import authUk from './uk/auth.json';

export const sharedResources = {
  en: {
    common: commonEn,
    validation: validationEn,
    errors: errorsEn,
    auth: authEn,
  },
  uk: {
    common: commonUk,
    validation: validationUk,
    errors: errorsUk,
    auth: authUk,
  },
};

export default sharedResources;
